module.exports = __webpack_public_path__ + "img/golf-club.ab93ce83.svg";